// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26MBX","label":"styles_label__1NCnP"};